export enum ClientType {
    Unknown,
    Web,
    Mac,
    Windows
}